var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.47 2.928a.75.75 0 0 1 1.003-.052l.057.052 4.667 4.667.02.022.008.01.023.025q.016.021.03.044.015.022.031.047.019.03.033.063.014.03.026.06a1 1 0 0 1 .022.075q.008.024.013.05a.8.8 0 0 1 0 .267q-.006.029-.014.056-.009.035-.021.07-.013.032-.03.065-.011.027-.027.053l-.04.06q-.01.018-.023.036l-.02.021-.013.015-.018.022-4.667 4.666a.75.75 0 1 1-1.06-1.061l3.384-3.386H3.333a.75.75 0 0 1 0-1.5h7.523L7.47 3.99l-.052-.057a.75.75 0 0 1 .052-1.004"
  })));
};
export default Svg16;